import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 50000-50999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const miscErrors = {
  // 50xxx is a shared block for the one-site modules that do not justify a range of their own.
  VIEWER_SETTINGS_WRITE_NOT_ACKNOWLEDGED: {
    errorCode: 50001,
    errorMessage: t("The viewer settings write was not acknowledged."),
    isDynamic: false,
  },
  // 50002 (PORTAL_FRONTEND_URL_REQUIRED) is retired: nothing sends it. Do not reuse the number.
  MOBILE_APP_VERSION_FETCH_FAILED: {
    errorCode: 50003,
    errorMessage: t("Failed to fetch the latest app version"),
    isDynamic: false,
  },
  LINK_NO_HTTP_URL_FOUND: {
    errorCode: 50004,
    errorMessage: t("No http(s) URL was found in the submitted link."),
    isDynamic: false,
  },
  LINK_URL_INVALID: {
    errorCode: 50005,
    errorMessage: t("The submitted link is not a valid URL."),
    isDynamic: false,
  },
  MOBILE_LATEST_VERSION_UNDETERMINED: {
    errorCode: 50006,
    errorMessage: t('Could not determine the latest published version for platform "{{platform}}"'),
    isDynamic: true,
    dynamicParams: ["platform"],
  },
  // The three "no document matched" exits of `getUserSettings` (userSettings/userSettingMongo.service.ts).
  // `status: false` there does NOT mean the read failed — it means this user has no stored setting for
  // the key, which is an ordinary first-visit state the caller answers with its own defaults. It carries
  // a code because every `status: false` must name one; no UI is expected to show this sentence.
  USER_SETTING_NOT_FOUND: {
    errorCode: 50007,
    errorMessage: t("No saved setting was found."),
    isDynamic: false,
  },
  EMAIL_NOTIFICATION_MODULE_UNKNOWN: {
    errorCode: 50008,
    errorMessage: t("Email notifications cannot be set for this module."),
    isDynamic: false,
  },

  EMAIL_NOTIFICATION_SETTINGS_MISMATCH: {
    errorCode: 50009,
    errorMessage: t("The email notifications sent do not match this module's notifications."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
